import { BsArrowBarDown, BsArrowBarUp } from 'react-icons/bs';
import { FC, useState } from 'react';
import { generalBlue } from 'src/app-config';
import { Hr } from 'src/components/_commons';
import { HTHFaceBuildingsAdd } from './HTHSectionFaceBuildingsAdd';
import { HTHFaceBuildingsItem } from './HTHSectionFaceBuildingsItem';
import { HTHFaceBuildingsShareButton } from './HTHSectionFaceBuildingsShareButton';
import { typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useGetCurrentUser, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    currentFace: typeHTHFace;
    territoryNumber: typeTerritoryNumber;
};

export const HTHFaceBuildings: FC<propsType> = ({ currentFace, territoryNumber }) => {
    const [show, setShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const isMobile = useGetIsMobile();
    const user = useGetCurrentUser();

    return (
        <div style={{ marginTop: '100px', marginBottom: '50px' }}>
            {showModal &&
                <HTHFaceBuildingsAdd
                    closeModal={() => setShowModal(false)}
                    currentFace={currentFace}
                    territoryNumber={territoryNumber}
                />
            }
            <h1 className={'py-3 text-center text-white d-block mx-auto pointer rounded-3'}
                style={{
                    backgroundColor: !!currentFace.buildings?.length ? generalBlue : 'gray',
                    marginBottom: '50px',
                    width: isMobile ? '100%' : '90%'
                }}
                onClick={() => setShow(x => !x)}
            >
                {!!currentFace.buildings?.length ?
                    'EDIFICIOS '
                    :
                    'No hay edificios en esta cara '
                }
                {show ?
                    <><BsArrowBarUp size={isMobile ? '1.6rem' : '1.4rem'} /></>
                    :
                    <><BsArrowBarDown size={isMobile ? '1.6rem' : '1.4rem'} /></>
                }
            </h1>
            {show &&
                <>
                {user.isBuildingsAdmin &&
                    <button className={'btn btn-general-red d-block mx-auto py-2'}
                        onClick={() => setShowModal(true)}
                        style={{ width: '250px' }}
                    >
                        Agregar Edificio
                    </button>
                }
                <Hr classes={'mx-auto my-4'} styles={{ maxWidth: '500px' }} />
                {!!currentFace.buildings?.length &&
                    <>
                    {currentFace.buildings.sort((b1, b2) => b1.streetNumber - b2.streetNumber).map(building =>
                        <HTHFaceBuildingsItem key={building.streetNumber}
                            building={building}
                            currentFace={currentFace}
                            territoryNumber={territoryNumber}
                        />
                    )}
                    <Hr />
                    <HTHFaceBuildingsShareButton
                        currentFace={currentFace}
                        territoryNumber={territoryNumber}
                    />
                    </>
                }
                </>
            }
        </div>
    );
}
